import React from "react";
import { motion, cubicBezier } from "framer-motion";

//Data
import { smashData } from "../data/smashData";

//Default transition
const easing = cubicBezier(0.6, 0.01, -0.05, 0.9);
const transition = { duration: 0.8, ease: easing };

const renderList = (items, setActiveObject, workingHours, getClass) =>
  items.map((product) => (
    <motion.li
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2.4, ...transition }}
      key={product.id}
      onClick={() => {
        setActiveObject(product);
        workingHours();
      }}
      className={getClass(product.id)}
    >
      <img className="list-img" src={product.image} alt="Ресторан идзуо" />
      <span className="list-menu-info">
        <span className="list-menu-top">
          <span className="list-title">{product.name}</span>
          <span className="list-desc">{product.desc}</span>
        </span>
        <span className="list-price">{product.price} рсд</span>
      </span>
    </motion.li>
  ));

const Smash = (props) => {
  const { setActiveObject, workingHours, getClass } = props;
  const SmashOffers = smashData.filter(
    (item) => item.category === "smashOffer",
  );
  const Burgers = smashData.filter(
    (item) => item.category === "burger" && item.isBaseVariant,
  );
  const Smashsides = smashData.filter((item) => item.category === "smashsides");
  const Smashdrinks = smashData.filter(
    (item) => item.category === "smashdrinks",
  );

  return (
    <>
      {SmashOffers.length > 0 && (
        <>
          <motion.h4
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            className="menu-title"
          >
            <span>Акције</span>
          </motion.h4>
          <ul className="list-menu offer smash smash-grid">
            {renderList(SmashOffers, setActiveObject, workingHours, getClass)}
          </ul>
        </>
      )}

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Бургери</span>
      </motion.h4>
      <ul className="list-menu smash smash-grid">
        {renderList(Burgers, setActiveObject, workingHours, getClass)}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Прилози</span>
      </motion.h4>
      <ul className="list-menu smash smash-grid">
        {renderList(Smashsides, setActiveObject, workingHours, getClass)}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пића</span>
      </motion.h4>
      <ul className="list-menu smash smash-grid">
        {renderList(Smashdrinks, setActiveObject, workingHours, getClass)}
      </ul>
    </>
  );
};

export default Smash;
